<template>
	<div class="integrations">
		<ul class="integrations__list">
			<li
				v-for="(integration, index) in source"
				:id="`${uid}_${index}`"
				class="integrations__list-item"
				:key="index"
				data-test="integrationsList"
			>
				<IntegrationsSumaryCard
					v-on="$listeners"
					:source="integration"
				/>
			</li>
		</ul>
	</div>
</template>

<script>
import IntegrationsSumaryCard from './integrations-summary-card';

export default {
	name: 'IntegrationsSummaryList',
	components: {
		IntegrationsSumaryCard
	},
	props: {
		source: {
			type: Array,
			default: () => []
		}
	}
};
</script>

<style lang="scss">
/**
	* 3P Vendor Integration Manager - Results List
	* Can use SCSS variables = TRUE
*/

.integrations {
	&__list {
		display: grid;
		grid-template-columns: 1fr;
		gap: $gutter-lg;

		@include mq($from: md) {
			grid-template-columns: 1fr 1fr;
		}

		@include mq($from: lg) {
			grid-template-columns: 1fr 1fr 1fr;
		}
	}
}
</style>
